module.exports = __webpack_public_path__ + "img/skridsko_moto.f932f9df.jpg";